import request from '../utils/request';

// export const fetchData = query => {
//     return request({
//         url: './table.json',
//         method: 'get',
//         paramss: query
//     });
// };
const api = {
    login (data) {
        return request({
            url: '/user/login',
            method: 'POST',
            data
        })
    },
    // 获取文件夹列表
    loadFolderLit (data = {}) {
        return request({
            url: '/folder/listFolderInfo',
            method: 'POST',
            data
        })
    },
    // 添加文件夹
    addFolder (data) {
        return request({
            url: '/folder/addFolderInfo',
            method: 'POST',
            data
        })
    },
    // 删除文件夹
    deleteFolder (data) {
        return request({
            url: '/folder/deleFolderInfo',
            method: 'POST',
            data
        })
    },
    // 更新文件夹
    updateFolder (data) {
        return request({
            url: '/folder/updateFolderInfo',
            method: 'POST',
            data
        })
    },
    // 上传文件
    uploadFile (data) {
        return request({
            url: '/file/setAttachment?fileType=img',
            method: 'POST',
            data
        }, 'upload')
    },
    // 下载文件夹
    downloadFolder (data, progress) {
        return request({
            url: '/file/downlowndFolderAllFile',
            method: 'GET',
            params: data,
            responseType: 'blob',
            onDownloadProgress: progress,
            timeout: 1000 * 60 * 1000,
        })
    },
    // 按字段导出文件夹（不含图片）
    downlowndFolderField (data, progress) {
        return request({
            url: '/file/downlowndFolderField',
            method: 'POST',
            data: data,
            responseType: 'blob',
            onDownloadProgress: progress,
            timeout: 1000 * 60 * 1000,
        })
    },
    // 添加字段
    addScheme (data) {
        return request({
            url: '/field/addFieldInfo',
            method: 'POST',
            data
        })
    },
    // 查询字段
    loadScheme (data) {
        return request({
            url: '/field/listFieldInfo',
            method: 'POST',
            data
        })
    },
    // 编辑字段
    editScheme (data) {
        return request({
            url: '/field/updateFieldInfo',
            method: 'POST',
            data
        })
    },
    // 删除字段
    deleteScheme (data) {
        return request({
            url: '/field/deleFieldInfo',
            method: 'POST',
            data
        })
    },
    // 查询路径信息
    loadLevelsInfo (data) {
        return request({
            url: '/folder/listFolderInfoByOrder',
            method: 'POST',
            data
        })
    },
    // 查询表单类型列表
    loadFormTypeList (data) {
        return request({
            url: '/field/listFieldTypeInfo',
            method: 'POST',
            data
        })
    },
    // 添加表单类型
    addFormTypeList (data) {
        return request({
            url: '/field/addFieldTypeInfo',
            method: 'POST',
            data
        })
    },
    // 删除表单类型
    deleteFormTypeList (data) {
        return request({
            url: '/field/deleFieldTypeInfo',
            method: 'POST',
            data
        })
    },
    // 添加单个文件信息
    addFileData (data) {
        return request({
            url: '/field/addFieldValueInfos',
            method: 'POST',
            data
        })
    },
    // 编辑单个文件数据
    editFileData (data) {
        return request({
            url: '/field/updateFolderFieldValueInfo',
            method: 'POST',
            data
        })
    },
    // 获取文件信息
    loadFileData (data) {
        return request({
            url: '/field/listFolderFieldValueInfoByBatch',
            method: 'POST',
            data
        })
    },
    // 删除文件
    delFileData (data) {
        return request({
            url: '/field/deleFolderFieldValueInfo',
            method: 'POST',
            data
        })
    },
    // 获取文件列表
    loadFileDataList (data) {
        return request({
            url: '/field/listFolderFieldValueInfo',
            method: 'POST',
            data
        })
    },
    // 获取二维码
    loadQRCode (data) {
        return request({
            url: '/folder/getSmallProgramQRCodeByte',
            method: 'POST',
            data
        })
    },
    // 获取管理员列表
    loadUserList (data) {
        return request({
            url: '/user/listUserInfo',
            method: 'POST',
            data
        })
    },
    // 获取文件夹管理员
    loadFolderUserList (data) {
        return request({
            url: '/userFolder/listFolderUser',
            method: 'POST',
            data
        })
    },
    // 获取文件夹管理员
    addUser (data) {
        return request({
            url: '/user/addUser',
            method: 'POST',
            data
        })
    },
    // 编辑用户
    editUser (data) {
        return request({
            url: '/user/changeUserPassword',
            method: 'POST',
            data
        })
    }
}
export default api